export class SuggestionFilterModel {
  constructor(public id: number, public title: string) {}
}
